/**
 * Normalise la réponse getCommercants — ids gardés en mémoire, jamais affichés.
 * @param {unknown} data
 * @returns {{ id: string, nom: string, ville?: string|null }[]}
 */
export function normalizeCommercantsList(data) {
  let entries = [];
  if (Array.isArray(data)) entries = data;
  else if (Array.isArray(data?.data)) entries = data.data;
  else if (Array.isArray(data?.commercants)) entries = data.commercants;
  else if (Array.isArray(data?.items)) entries = data.items;

  return entries
    .map((c) => {
      const id = c?.id;
      const nom = c?.nom && String(c.nom).trim();
      if (!id || !nom) return null;
      const ville =
        (c.ville && String(c.ville).trim()) ||
        (c.adresse?.ville && String(c.adresse.ville).trim()) ||
        null;
      return { id, nom, ville };
    })
    .filter(Boolean);
}

/**
 * Filtre local par nom (et ville).
 * @param {{ id: string, nom: string, ville?: string|null }[]} list
 * @param {string} query
 */
export function filterCommercantsByName(list, query) {
  const q = String(query || '')
    .trim()
    .toLowerCase();
  if (q.length < 1) return Array.isArray(list) ? list.slice(0, 30) : [];
  return (list || [])
    .filter((c) => {
      const blob = `${c.nom} ${c.ville || ''}`.toLowerCase();
      return blob.includes(q);
    })
    .slice(0, 40);
}
